import React, {Fragment, useEffect} from 'react'
import WebViewer from '@pdftron/webviewer'

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'

// Custom Style
import {filePreviewStyle} from '../../styles/jss/components/filePreview/filePreviewStyle'

// Global Function
import {webViewerLoadDocument} from "../../global/webViewerLoadDocument"


const useStyles = makeStyles(theme => filePreviewStyle(theme))


const FilePreview = props => {
	const classes = useStyles()
	const {filePreviewProperty, annotationChangeAlert, setAnnotationChangeAlert} = props



	useEffect(() => {
		if (document.getElementById('webviewer')) {
			document.getElementById('webviewer').innerHTML = ''
		}

		console.log("*****************************************************************************")
		console.log("Webviewer Area")
		console.log(document.getElementById('webviewer'))
		console.log("*****************************************************************************")

		WebViewer({
			path: process.env.REACT_APP_PDFTRON_PATH,
			licenseKey: process.env.REACT_APP_PDFTRON_LICENSE_KEY
			// config: 'config.js' // path/to/your/config.js
		}, document.getElementById('webviewer')).then(instance => {
			
			webViewerLoadDocument("workflow", filePreviewProperty.fileCategory, null, filePreviewProperty.fileSequence, "abc.pdf")

			// instance.docViewer.loadDocument(
			// 	`http://172.16.145.30:3002/api/v1/file/download?file_cat=${filePreviewProperty.fileCategory}&file_seq=${filePreviewProperty.fileSequence}`, {
			// 	customHeaders: {
			// 		"Authorization": "Bearer " + store.get('access_token'),
			// 		"site": store.get('site'),
			// 		"locale": store.get('locale')
			// 	}
			// })
		})
	}, [])

	return (
		<Fragment>
			<div className={classes.webviewer} id="webviewer"></div>
		</Fragment>
	)
}


export default FilePreview